const getDateKeyFromTimeKey = (key) => {
  const newKey = [...key.split('_')];
  newKey[1] = 'date';
  return newKey.join('_');
};

export default getDateKeyFromTimeKey;
